<template>
  <header>
    <div class="header-area">
      <div id="sticky-header" class="main-header-area">
        <div class="container-fluid p-0">
          <div class="row align-items-center no-gutters">
            <div class="col-xl-2 col-lg-2">
              <div class="logo-img">
                <a href="#" @click.prevent="goLink('/')">
                  <img src="@/assets/images/logo.png" alt="" />
                </a>
              </div>
            </div>
            <div class="col-xl-7 col-lg-7">
              <div class="main-menu d-none d-lg-block">
                <nav>
                  <ul id="navigation">
                    <li v-for="(menu, key) in menuMap" :key="key">
                      <a
                        :class="menu.class"
                        href="#"
                        @click.prevent="goLink(menu.link)"
                        >{{ menu.text }}</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 d-none d-lg-block">
              <div class="log_chat_area d-flex align-items-center">
                <div class="live_chat_btn">
                  <a class="boxed_btn_orange" href="https://study.onecode.pro">
                    <span>学习平台</span>
                  </a>
                </div>
                <div class="live_chat_btn" style="padding-left: 5px;">
                  <a class="boxed_btn_orange" href="https://oj.onecode.pro">
                    <span>OJ平台</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mobile_menu d-block d-lg-none"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import $ from "jquery";

export default defineComponent({
  mounted() {
    $(window).on("scroll", function () {
      var scroll = $(window).scrollTop();
      if (scroll < 400) {
        $("#sticky-header").removeClass("sticky");
        $("#back-top").fadeIn(500);
      } else {
        $("#sticky-header").addClass("sticky");
        $("#back-top").fadeIn(500);
      }
    });
  },
  setup() {
    const url = window.location.href;
    const router = useRouter();
    const menuMap = [
      { text: "主页", link: "/" },
      { text: "课程", link: "/courseShop" },
      { text: "关于我们", link: "/about" },
      { text: "联系我们", link: "/concat" },
    ];
    let activeMenu = menuMap.find((item) => url.endsWith(item.link));
    if (activeMenu) {
      activeMenu.class = "active";
    }

    // 跳转详情页面
    const goLink = (link) => {
      router.push(link);
    };
    return { menuMap, goLink };
  },
});
</script>
